/**
 * @file: ConversationSkeleton.tsx
 *
 * The placeholder shown while a deep-link `roomId` is being resolved into a
 * room identity (see the screen's gate). It renders the conversation chrome
 * — an (embedded) header, an empty message area, and an inert composer bar —
 * so the screen doesn't flash blank or a bare spinner before the real
 * conversation mounts.
 */

import { PaneHeader } from '@euler/components/PaneHeader';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useSystemMetrics } from '@euler/functions/useSystemMetrics';
import { FC, memo } from 'react';
import { StyleSheet, View } from 'react-native';

export const ConversationSkeleton: FC<{ embedded?: boolean }> = memo(
  ({ embedded }) => {
    const { rpx } = useResponsiveContext();
    const { safeAreaInsets } = useSystemMetrics();
    return (
      <View style={{ flex: 1, backgroundColor: '#fafafa' }}>
        {embedded ? <PaneHeader title="" /> : null}
        <View style={{ flex: 1 }} />
        <View
          style={{
            backgroundColor: '#fafafa',
            paddingTop: rpx(8),
            paddingHorizontal: rpx(12),
            paddingBottom: safeAreaInsets.bottom + rpx(8),
          }}
        >
          <View
            style={{
              height: rpx(40),
              borderRadius: rpx(20),
              backgroundColor: '#fff',
              borderWidth: StyleSheet.hairlineWidth,
              borderColor: '#e5e7eb',
            }}
          />
        </View>
      </View>
    );
  },
);
